










import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

@Component({
  components: {
  }
})
export default class AcgnFormContent extends Vue {
  public name: string = 'AcgnFormContent';
}
